/**
 * CardsView.jsx
 * Vista de tarjetas reutilizable
 */
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from "./ui/card";
import { Badge } from "./ui/badge";

export default function CardsView({ 
  items = [], 
  renderCard,
  onItemClick,
  columns = 3 // Number of columns in grid
}) {
  const gridCols = {
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4',
  };

  return (
    <div className={`grid ${gridCols[columns] || gridCols[3]} gap-4`}>
      {items.map((item, idx) => (
        <Card 
          key={item.id || idx}
          className="cursor-pointer hover:shadow-lg transition-all hover:scale-[1.02] bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700"
          onClick={() => onItemClick?.(item)}
        >
          {renderCard ? renderCard(item) : (
            <>
              <CardHeader className="pb-2">
                <CardTitle className="text-base font-semibold text-slate-900 dark:text-white">
                  {item.titulo || item.cliente || item.name || 'Sin título'}
                </CardTitle>
              </CardHeader>
              <CardContent className="pb-2">
                <p className="text-sm text-slate-600 dark:text-slate-300 line-clamp-2">
                  {item.descripcion || item.notas || 'Sin descripción'}
                </p>
              </CardContent>
              <CardFooter className="pt-2 flex justify-between items-center">
                <Badge variant="outline">
                  {item.estado || item.status || 'N/A'}
                </Badge>
                {item.prioridad && (
                  <Badge 
                    className={
                      item.prioridad === 'critica' || item.prioridad === 'alta' 
                        ? 'bg-red-100 text-red-700' 
                        : item.prioridad === 'media' 
                        ? 'bg-yellow-100 text-yellow-700'
                        : 'bg-green-100 text-green-700'
                    }
                  >
                    {item.prioridad}
                  </Badge>
                )}
              </CardFooter>
            </>
          )}
        </Card>
      ))}
      
      {items.length === 0 && (
        <div className="col-span-full text-center py-12 text-slate-400">
          No hay items para mostrar
        </div>
      )}
    </div>
  );
}
